import { FlexBox } from "components/Common/FlexBox"
import {
  ConfirmBody,
  ConfirmEntry,
  ConfirmTitle,
  IconWrapper,
  StyledModal,
} from "./styled"
import TrashIcon from "components/Icons/TrashIcon"
import Button from "components/Buttons/Button"
import InfoIcon from "components/Icons/InfoIcon"
import React from "react"
import SecondaryButton from "components/Buttons/SecondaryButton"
import PrimaryLightButton from "components/Buttons/PrimaryLightButton"

interface IPopConfirmProps {
  isOpen: boolean
  title: string
  loading: boolean
  onCancel: () => void
  onConfirm: () => void
  type?: "danger" | "info" | "modal"
  children: React.ReactNode
  cancelText?: string
  confirmText?: string
  disabled?: boolean
  maxLines?: number
  isCancelButtonLoading?: boolean
  isSecondaryCancel?: boolean
  titleStyle?: React.CSSProperties
}

const PopConfirm = (props: IPopConfirmProps) => {
  const {
    isOpen,
    title,
    cancelText = "No, Keep it",
    confirmText = "Yes, Delete",
    loading,
    onCancel,
    onConfirm,
    type = "info",
    children,
    disabled,
    maxLines = 3,
    isCancelButtonLoading,
    isSecondaryCancel,
    titleStyle = {},
  } = props
  return (
    <StyledModal
      style={
        {
          "--app-max-width": "450px",
          "--horizontal-margin": "48px",
          "--max-width":
            "calc(min(100vw,var(--app-max-width)) - var(--horizontal-margin))",
          "--min-width":
            "calc(min(100vw,var(--app-max-width)) - var(--horizontal-margin))",
        } as React.CSSProperties
      }
      visible={isOpen}
      content={
        <FlexBox $direction="column" $gap={16} style={{ width: "100%" }}>
          <FlexBox $direction="column" $gap={type === "modal" ? 0 : 4}>
            <FlexBox $justify="center">
              {type === "modal" ? undefined : type === "info" ? (
                <IconWrapper $type="info">
                  <InfoIcon />
                </IconWrapper>
              ) : (
                <IconWrapper $type="danger">
                  <TrashIcon color="#FF4921" />
                </IconWrapper>
              )}
            </FlexBox>
            <ConfirmTitle style={titleStyle} $type={type}>
              {title}
            </ConfirmTitle>

            <ConfirmBody $maxLines={maxLines}>{children}</ConfirmBody>
          </FlexBox>

          <FlexBox $gap={16}>
            {isSecondaryCancel ? (
              <PrimaryLightButton
                $size="small"
                onClick={onCancel}
                disabled={loading}
                style={{ width: "50%" }}
                loading={!!isCancelButtonLoading}
              >
                {cancelText}
              </PrimaryLightButton>
            ) : (
              <Button
                onClick={onCancel}
                disabled={loading}
                style={{ width: "50%" }}
                $type="cancel"
                $size="small"
                loading={!!isCancelButtonLoading}
              >
                {cancelText}
              </Button>
            )}

            <Button
              disabled={disabled}
              onClick={onConfirm}
              loading={loading}
              style={{ width: "50%" }}
              $type={type === "danger" ? "danger" : "info"}
              $size="small"
            >
              {confirmText}
            </Button>
          </FlexBox>
        </FlexBox>
      }
    ></StyledModal>
  )
}

export default PopConfirm
